<div class="package-selection-actions" [attr.aria-busy]="loading() ? 'true' : null">
  @if (loading()) {
    <output class="visually-hidden" data-testid="package-save-processing-status">
      {{ 'createShipment.actions.saveAndContinueSaving' | translate }}
    </output>
  }

  <puro-button
    type="button"
    variant="secondary"
    size="large"
    data-testid="package-back"
    [disabled]="interactionDisabled() || loading()"
    (buttonClick)="onBack()"
  >
    {{ 'createShipment.packageStep.actions.back' | translate }}
  </puro-button>

  <!-- Page owns navigation: advances to /service only when the form is valid. -->
  <puro-button
    type="button"
    variant="primary"
    size="large"
    data-testid="package-save-continue"
    [loading]="loading()"
    [disabled]="interactionDisabled() || loading()"
    (buttonClick)="onSaveAttempt()"
  >
    {{ 'createShipment.packageStep.actions.saveAndContinue' | translate }}
  </puro-button>
</div>
